import { useQuery } from "@tanstack/react-query";
import { validate } from "uuid";
import { getCustomAttribute, getCustomAttributes } from "../api";

export const useCustomAttributes = (filters) =>
	useQuery({
		queryFn: () => getCustomAttributes(filters),
		queryKey: ["customAttributes", filters],
	});

export const useCustomAttribute = (id) =>
	useQuery({
		queryFn: () => getCustomAttribute(id),
		enabled: validate(id),
		queryKey: ["customAttributes", { id }],
	});
